import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import InputMask from 'react-input-mask';
import Pagination from '../Common/Pagination';
import Swal from 'sweetalert2';
import { Context } from '../../context/UserContext';
import moment from "moment-jalali";
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';

const ConfirmRequest = () => {


    const context = useContext(Context);
    const { readData } = useEntityCrud('ServiceConsumer/GetAllServiceConsumer');
    const [rows, setRows] = useState([]);
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pan, setPan] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [consumerNationalCode, setConsumerNationalCode] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const [searched, setSearched] = useState(false);

    const getData = (searchData) => {

        setShowLoading(true);
        const postedData = {
            offset: 0,
            limit: 10,
            ...searchData
        };
        readData(postedData).then(res => {

            if (res.data.status) {
                calcPages(res);
                setRows(res.data.result.filter(item => item.status === 3));
            } else {
                setRows([]);
                setPages([]);
            }
            setShowLoading(false);
        })
    }

    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("jYYYYjMMjDD");
    }


    useEffect(() => {
        const postedData = {
            "fromdate": convertToDate(fromDate) || convertToDate(getToday()),
            "todate": convertToDate(toDate) || convertToDate(getToday()),
        };
        getData(postedData);
    }, [fromDate, toDate])

    const calcPages = res => {
        let calcPages = res.data.count / 10;
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setShowLoading(true);

        setCurrentPage(page);
        const postedData = {
            limit: 10,
            offset: page - 1
        };
        if (fromDate)
            postedData.fromDate = parseInt(fromDate.replace(/\//g, ''));
        if (toDate)
            postedData.toDate = parseInt(toDate.replace(/\//g, ''));
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (pan)
            postedData.pan = pan;
        readData(postedData).then(res => {
            setShowLoading(false);

            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const prevPage = e => {
        setShowLoading(true);
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            limit: 10,
            offset: currentPage - 2
        };
        if (fromDate)
            postedData.fromDate = parseInt(fromDate.replace(/\//g, ''));
        if (toDate)
            postedData.toDate = parseInt(toDate.replace(/\//g, ''));
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (pan)
            postedData.pan = pan;
        readData(postedData).then(res => {
            setShowLoading(false);

            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const nextPage = e => {
        setShowLoading(true);

        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            limit: 10,
            offset: currentPage
        };
        if (fromDate)
            postedData.fromDate = parseInt(fromDate.replace(/\//g, ''));
        if (toDate)
            postedData.toDate = parseInt(toDate.replace(/\//g, ''));
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (pan)
            postedData.pan = pan;
        readData(postedData).then(res => {
            setShowLoading(false);
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    function getToday() {
        const today = moment().format("jYYYY-jMM-jDD").split("-")
        return {
            year: +today[0],
            month: +today[1],
            day: +today[2]
        }
    }


    return (


        <div>

            {showLoading ? <div className="loading-box">
                <img src="/assets/images/loading.gif" alt="" />
            </div> : ''}

            <div className="row" style={{ display: "none" }} >
                <div className="col-md-3 deskTopShow" style={{ position: "relative", zIndex: "9" }}>
                    <div className="form-group">
                        <label htmlFor="issueDate"> از تاریخ    </label><br />
                        <DatePicker
                            name="fromDate"
                            required
                            locale="fa"
                            shouldHighlightWeekends
                            value={fromDate || getToday()}
                            onChange={setFromDate}
                            className="form-control"
                            inputPlaceholder=' تاریخ  را انتخاب کنید ...'
                        />
                    </div>
                </div>
                <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                    <div className="form-group">
                        <label htmlFor="toDate"> تا تاریخ     </label><br />
                        <DatePicker
                            name="toDate"
                            required
                            locale="fa"
                            shouldHighlightWeekends
                            value={toDate || getToday()}
                            onChange={setToDate}
                            className="form-control"
                            inputPlaceholder='  تاریخ را انتخاب کنید ...'
                        />
                    </div>
                </div>

            </div>



            {rows?.length ?
                <div className="row">
                    {rows.map((item, index) => (
                        <div className="col-md-6" key={index}>
                            <div className="card custom-border-1">
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="buyer-name">خریدار: {item.personFullName}</p>
                                        <p className="business-title">کسب و کار: {item.businessTitle}</p>
                                        <p className="total-amount">مبلغ کل: {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalAmount)} ریال</p>
                                        <p className="discount-amount">مبلغ تخفیف: {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalDiscount)} ریال</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="paid-amount">مبلغ پرداخت شده: {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalPay)} ریال</p>
                                        <p className="payment-type">روش پرداخت: {item.paymentType === 1 ? <span>  اعتباری </span> : item.paymentType === 2 ? <span >  نقدی</span> : item.paymentType === 3 ? <span >  ترکیبی </span> : "-"}</p>
                                        <p className="card-number" dir="ltr">{item.pan}</p>
                                        <p className="created-time">{(item.registerTime || '-') + ' ' + (item.registerDate == null ? '-' : (item.registerDate.toString().slice(0, 4) + '-' + item.registerDate.toString().slice(4, 6) + '-' + item.registerDate.toString().slice(6, 8)))}</p>
                                    </div>
                                </div>
                                <span className="payment-status"><span className="badge bg-success">تایید درخواست</span></span>
                                <div className="operation-btn-group">
                                    {context.checkHasPermission('read') ? <Link to={'service-consumer/view/' + item.serviceConsumerId} className="btn btn-icon me-1 mb-0 btn-primary"><i className="fe fe-eye"></i></Link> : ''}
                                    {context.checkHasPermission('read') ? <Link to={'service-consumer/factor/' + item.serviceConsumerId} target="_blank" className="btn btn-icon mb-0 btn-info  me-1"><i className="fe fe-printer"></i></Link> : ''}
                                    {context.checkHasPermission('read') ? <Link to={'service-consumer/update/' + item.serviceConsumerId} target="_blank" className="btn btn-icon mb-0 btn-secondary"><i className="fe fe-edit"></i></Link> : ''}
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="col-12">
                        <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} />
                    </div>
                </div>
                : <div className="alert alert-info"><p>داده ای یافت نشد</p></div>}
        </div>




    )
}

export default ConfirmRequest;
